module.exports = __webpack_public_path__ + "static/23-tat6-625c960b5020405e8f7efebafee4dcbd.jpg";